export default __webpack_public_path__ + "e141dd34126be49abd5fe8e4c2255bb4.png";